import FilterFactory from '@/lib/filterFactory';

const enum FilterKey {
    Name = 'fullName',
    Email = 'email',
    Phone = 'phone',
    Clinic = 'clinic',
    Specialization = 'specialization',
    WithInactive = 'withInactive',
}
export default class DoctorsFilter {
    filterHandlers = {
        update: 'doctorsFilter/updateFilter',
        reset: 'doctorsFilter/resetFilter',
        resetState: 'doctorsFilter/resetFilterState',
        removeSelected: 'doctorsFilter/removeSelectedFilter',
    };
    filterModel: Record<string, any>;

    constructor() {
        const filter = new FilterFactory();

        filter.createSearchEntity(FilterKey.Name);
        filter.setPlaceholder(FilterKey.Name, 'По имени');
        filter.setName(FilterKey.Name, 'search_doctorsTitle');
        filter.setPreviewName(FilterKey.Name, 'Имя');
        filter.setClassName(FilterKey.Name, 'col-1-row-1');
        filter.setIconClassName(FilterKey.Name, 'icon-clients');
        filter.setAction(FilterKey.Name, 'doctorsFilter/updateSearch');

        filter.createSearchEntity(FilterKey.Email);
        filter.setPlaceholder(FilterKey.Email, 'По email');
        filter.setName(FilterKey.Email, 'search_doctorsEmail');
        filter.setPreviewName(FilterKey.Email, 'E-mail');
        filter.setClassName(FilterKey.Email, 'col-1-row-2');
        filter.setIconClassName(FilterKey.Email, 'icon-email');
        filter.setAction(FilterKey.Email, 'doctorsFilter/updateSearch');

        filter.createSearchEntity(FilterKey.Phone);
        filter.setPlaceholder(FilterKey.Phone, 'По телефону');
        filter.setName(FilterKey.Phone, 'search_doctorsPhone');
        filter.setPreviewName(FilterKey.Phone, 'Телефон');
        filter.setClassName(FilterKey.Phone, 'col-1-row-3');
        filter.setIconClassName(FilterKey.Phone, 'icon-phone');
        filter.setAction(FilterKey.Phone, 'doctorsFilter/updateSearch');

        filter.createAutocompleteEntity(FilterKey.Clinic);
        filter.setPlaceholder(FilterKey.Clinic, 'По клинике');
        filter.setName(FilterKey.Clinic, 'search_doctorsClinic');
        filter.setPreviewName(FilterKey.Clinic, 'Клиника');
        filter.setClassName(FilterKey.Clinic, 'col-2-row-1');
        filter.setIconClassName(FilterKey.Clinic, 'icon-store');
        filter.setAction(FilterKey.Clinic, 'doctorsFilter/updateSearch');
        filter.setLoad(FilterKey.Clinic, {
            entityName: 'clinics',
        });
        
        filter.createAutocompleteEntity(FilterKey.Specialization);
        filter.setPlaceholder(FilterKey.Specialization, 'По специализации');
        filter.setName(FilterKey.Specialization, 'search_doctorsSpecialization');
        filter.setPreviewName(FilterKey.Specialization, 'Специализация');
        filter.setClassName(FilterKey.Specialization, 'col-2-row-2');
        filter.setIconClassName(FilterKey.Specialization, 'icon-position');
        filter.setAction(FilterKey.Specialization, 'doctorsFilter/updateSearch');
        filter.setLoad(FilterKey.Specialization, {
            entityName: 'specializations',
        });

        filter.createCheckboxEntity(FilterKey.WithInactive);
        filter.setName(FilterKey.WithInactive, 'checkbox_activity');
        filter.setPreviewName(FilterKey.WithInactive, 'Неактив');
        filter.setIconClassName(FilterKey.WithInactive, 'icon-check-mark');
        filter.setClassName(FilterKey.WithInactive, 'col-2-row-3');
        filter.setCheckboxList(FilterKey.WithInactive, [
            {
                id: '0',
                name: 'Показывать деактивированные',
                value: FilterKey.WithInactive,
                checked: false,
            }
        ]);
        filter.setAction(FilterKey.WithInactive, 'doctorsFilter/updateCheckbox');

        this.filterModel = filter.filterModel;
    }
}
